import Vue from "vue/dist/vue.esm";
import VueI18n from "vue-i18n";
import events from "/events";
import getLocale from "/utils/locale";
import TrialDurationExplanation from "/features/trial-duration-explanation/components/trial-duration-explanation";
import "/modules/load-plans";

Vue.use(VueI18n);

const init = (container, subscriptionPlan) => {
  if (!container) return;

  const {
    ctaCopy,
    ctaJsClass,
    piwikCategory,
    loggedInUserRedirect
  } = container.dataset;

  const redirectToCheckoutPage = container.dataset.redirectToCheckoutPage === "true";
  const includeReminderStep = container.dataset.includeReminderStep === "true";

  new Vue({
    name: "TrialDurationExplanationInit",
    el: container,
    i18n: new VueI18n({ locale: getLocale() }),
    render: h => h(TrialDurationExplanation, {
      props: {
        ctaCopy,
        ctaJsClass,
        piwikCategory,
        subscriptionPlan,
        redirectToCheckoutPage,
        loggedInUserRedirect,
        includeReminderStep
      }
    })
  });
};

events.on("plans:ready", data => {
  if (!data.canTrial) {
    return;
  }

  const containers = document.querySelectorAll(".vue-trial-duration-explanation");

  containers.forEach(container => {
    const subscriptionPlanDuration = parseInt(container.dataset.subscriptionPlanDuration, 10);

    const subscriptionPlan = data.plans.find(plan => {
      return plan.duration === subscriptionPlanDuration;
    });

    if (!subscriptionPlan) {
      return;
    }

    init(container, subscriptionPlan);
  });
});
